import {Pipe, PipeTransform} from "@angular/core";

​
@Pipe({
    name: 'formatDate'
})
export class FormatDatePipe implements PipeTransform {
​
    transform(timestamp: number): string {
        const date = new Date(timestamp);
        const day = date.getDate();
        const month = this.getMonthName(date.getMonth());
        const year = date.getFullYear();
        const ordinalSuffix = this.getOrdinalSuffix(day);
​
        return `${day}${ordinalSuffix} ${month}, ${year}`;
    }
​
    private getMonthName(month: number): string {
        const months = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];
​
        return months[month];
    }
​
    private getOrdinalSuffix(day: number): string {
        const suffixes = ['th', 'st', 'nd', 'rd'];
        const teenDigits = [11, 12, 13];
        const lastDigit = day % 10;
​
        if (teenDigits.includes(day)) {
            return suffixes[0];
        }
​
        return suffixes[lastDigit] || suffixes[0];
    }
​
}
